module.exports = __webpack_public_path__ + "media/images/soar/bgAuthIcon@2x-453c58a5d4f9426443159ec5cbc21405.png";